exports = module.exports = require("../../../node_modules/.pnpm/css-loader@1.0.1_webpack@4.46.0/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner_container_2gp3A {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n}\n.spinner_spinner_3_DJ6 {\n    width: 64px;\n    height: 64px;\n    border-radius: 50%;\n    border: 6px solid;\n    border-color: hsla(55, 90%, 60%, 1) transparent hsla(55, 90%, 60%, 1) transparent;\n    animation: spinner_spinner_3_DJ6 1.2s linear infinite;\n}\n[theme=\"dark\"] .spinner_spinner_3_DJ6 {\n    border-color: #fff transparent #fff transparent;\n}\n@keyframes spinner_spinner_3_DJ6 {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n", ""]);

// exports
exports.locals = {
	"container": "spinner_container_2gp3A",
	"spinner": "spinner_spinner_3_DJ6"
};